import { apiInstance } from "@/utils/ApiUtil.js";
const API_URL = "/admin/giveaway";

const getEntries = async (data) => {
    try {
        const response = await apiInstance.get(API_URL + "/entries", {
            params: {
                giveaway_id: data.giveaway_id,
            }
        });

        if (!response?.data?.success) return false;

        return response.data.items;
    } catch (error) {
        console.log(error);
        return false;
    }
};

const selectWinner = async (data) => {
    try {
        const response = await apiInstance.post(API_URL + "/determine-winner", {
            giveaway_id: data.giveaway_id
        });

        if (!response?.data?.success) {
            return {
                success: false,
                message: response?.data?.msg || "Failed to select winner",
                data: null
            };
        }

        return {
            success: true,
            message: response.data.msg,
            data: response.data.data
        };
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.msg || "Error selecting winner",
            data: null
        };
    }
};

const create = async (data) => {
    try {

        const response = await apiInstance.post(API_URL + "/create", {
            type: data.type,
            value: data.value,
            status: data.status,
            starts_at: data.starts_at,
            expires_at: data.expires_at,
            item_id: data.item_id,
            giveaway_type: data.giveaway_type
        });

        return response.data;
    } catch (error) {
        console.error("Error creating giveaway:", error);
        return null;
    }
};

const updateGiveaway = async (id, data) => {
    try {
        const response = await apiInstance.put(API_URL + `/giveaway/update/${id}`, {
            type: data.type,
            value: data.value,
            total_entries: data.total_entries || 0,
            starts_at: data.starts_at,
            expires_at: data.expires_at,
            item_id: data.item_id,
            status: data.status,
            giveaway_type: data.giveaway_type,
            winner_id: data.winner_id,
            usersId: data.usersId
        });
        return response.data;
    } catch (error) {
        console.error("Error updating giveaway:", error);
        return null;
    }
};

const deleteGiveaway = async (id) => {
    try {
        const response = await apiInstance.delete(API_URL + `/delete/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting giveaway:", error);
        return null;
    }
};

const AdminGiveawayService = {
    getEntries,
    create,
    updateGiveaway,
    deleteGiveaway,
    selectWinner
}

export default AdminGiveawayService;
